import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showModalOutletMobile } from 'actions';
import styles from './style.css';

class NavOutlet extends React.Component {
  render() {
    const {
      location,
      onMainButtonClick,
      selectedOutletIds,
      outlets,
    } = this.props;
    const showNavOutlet =
      location.pathname.startsWith('/dashboard') ||
      location.pathname.startsWith('/reports');

    let outletName = 'Loading...';
    if (selectedOutletIds.length > 1) {
      outletName = 'All';
    } else {
      const outlet = outlets.find(({ id }) => id === selectedOutletIds[0]);
      if (outlet) {
        outletName = outlet.name;
      }
    }

    return (
      showNavOutlet && (
        <div className={`${styles['nav-outlet-wrapper']}`}>
          <Link
            className={styles['nav-outlet-link']}
            onClick={onMainButtonClick}
          >
            <div className="cell-outlet">
              <div className="bar">
                <p className={styles['text-block-center']}>
                  {outletName}&nbsp;
                </p>
              </div>
              <div className="baz">
                <span className="caret" />
              </div>
            </div>
          </Link>
        </div>
      )
    );
  }
}

NavOutlet.propTypes = {
  outlets: PropTypes.array,
};

function mapStateToProps(state) {
  const { selectedOutletIds, outlets } = state.actionBar;
  return {
    selectedOutletIds,
    outlets,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onMainButtonClick: () => {
      dispatch(showModalOutletMobile(true));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavOutlet);
